// Connection mode controls SDK workflow lists and editor tabs, not API access.
// Metadata has `mode`; full integration detail has `settings.mode`.
export const isApiIntegration = (integration) => integration?.mode === 'connect' || integration?.settings?.mode === 'connect';
